export default __webpack_public_path__ + "static/media/honda.74a49130.svg";